export const formatReviewAddress = (address) => {
    if (!address) return "";

    const subPremise =
        typeof address.subPremise === "string"
            ? address.subPremise.trim()
            : "";
    const addressLine = subPremise
        ? `${address.streetAddress}, ${subPremise},`
        : `${address.streetAddress},`;

    return `${addressLine} ${address.suburb} ${address.state} ${address.postcode}.`;
};
